(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define("@aot-technologies/formio-export", ["_", "moment"], factory);
	else if(typeof exports === 'object')
		exports["@aot-technologies/formio-export"] = factory(require("lodash"), require("moment"));
	else
		root["@aot-technologies/formio-export"] = factory(root["_"], root["moment"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__23__) {
return 